import { StrictMode } from 'react';
import { Root } from './Root.js';
import { LocaleProvider } from './i18n/index.js';
import { ScreenBoundary } from './ui/ErrorBoundary.js';
import { ConsentBanner } from './consent/ConsentBanner.js';

/**
 * Everything React draws, in one place for both of the things that draw it:
 * the browser (`main.tsx`) and the build, which renders the landing page to
 * HTML ahead of time (`entry-server.tsx`). Adopting prerendered HTML only
 * works when both produce the same tree, so there is only one tree.
 */
export function PageTree({ prerendered }: { prerendered: boolean }) {
  return (
    <StrictMode>
      <LocaleProvider>
        {/* The last resort: the shell itself, session load, sidebar, router
            can throw too, and that failure used to be the same grey nothing. */}
        <ScreenBoundary>
          <Root prerendered={prerendered} />
        </ScreenBoundary>
        {/* Outside the app's own boundary and routing: the cookie question is
            the same on every page, public or signed in, and must not vanish
            with a screen that threw. */}
        <ConsentBanner />
      </LocaleProvider>
    </StrictMode>
  );
}
